import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUpload, faCog } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import { UseCampaignPayload } from '@hooks/useCampaign'

import handleCallbackAction from '@functions/handleCallbackAction'

type campaignPayloadProps = {
  campaignPayload: UseCampaignPayload,
}

const PortalDataTools = (props: campaignPayloadProps) => {
  const { campaignPayload } = props

  const {
    campaign: { published },
    callbacks: { portalSync: syncFn, managePortalDataDetailedFeatures },
    syncing,
  } = campaignPayload

  const portalSyncPayload = {
    callbacks: {
      action: syncFn,
    },
    toastText: 'Sync queued',
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCog} />}
        onClick={() => managePortalDataDetailedFeatures()}
        size="medium"
      >
        Detailed Features
      </Button>

      {published && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCloudUpload} />}
          loading={syncing}
          // @ts-expect-error TS2322
          marginTop="medium"
          onClick={() => handleCallbackAction(portalSyncPayload)}
          size="medium"
        >
          Send Data
        </Button>
      )}
    </Tools>
  )
}

export default PortalDataTools
